import { Box, Chip, Tooltip } from "@mui/material";
import { useContext } from "react";
import { useRecords } from "../../api/useRecords";
import { RecordContext } from "../../components/record/Record";

const EEG_FIRST_SERVICE_ID = 39;
const CREATED_BEFORE_DATE = "2026-07-16";
const STARTS_ON_OR_AFTER_DATE = "2026-07-23";

export const LeadInstrumentsSendManual = () => {
	// TODO remove this component and its implementation (its scoped to DetailHeader only) on 10/10/26, because it will be no longer needed
	// This component was used to flag lead that belong to the old instuemnts flow, where the instruments are sent on awaiting_in_clinic and not on booking
	// because of that, the current egg sms confirmation doesnt apply - so the Backoffice needs to be aware of these cases

	const record = useContext(RecordContext);
    const isLead = record?.entity === "leads";
    const leadId = isLead ? record?.item?.id : undefined;

    const { data: eegFirstSessions } = useRecords("sessions", "id", {
        enabled: !!leadId,
        extraOptions: {
            filter: {
                lead: { _eq: leadId },
                service: { _eq: EEG_FIRST_SERVICE_ID },
                treatment: { _null: true },
                status: { _in: ["booked", "confirmed"] },
                date_created: { _lt: CREATED_BEFORE_DATE },
                start_date: { _gte: STARTS_ON_OR_AFTER_DATE },
            },
            pageSize: 1,
        },
    });

    const hasPendingEegFirstSession = (eegFirstSessions?.items?.length ?? 0) > 0;

    const { data: instrumentsResponses } = useRecords("instruments_responses", "id", {
        enabled: !!leadId && hasPendingEegFirstSession,
        extraOptions: {
            filter: { lead: { _eq: leadId } },
            pageSize: 1,
        },
    });

    const hasInstrumentsResponses = (instrumentsResponses?.items?.length ?? 0) > 0;
    const showAlert = !!leadId && hasPendingEegFirstSession && !!instrumentsResponses && !hasInstrumentsResponses;

    if (!showAlert) return null;

    return (
        <Box display="flex" justifyContent="flex-end" mt={1}>
            <Tooltip title="Lead pertence a fluxo de instrumentos antigo, só os vai receber quando for à clínica para a avaliação">
                <Chip label="Se enviar SMS de confirmação - remover referência a questionários" color="warning" size="small" sx={{ width: "fit-content", px: 1 }} />
            </Tooltip>
        </Box>
    );
};
